"use client";
import { Box, HStack, Icon, Stack, SimpleGrid, GridItem } from "@chakra-ui/react";
import Link from "next/link";
import Image from "next/image";
import { FaRegEye } from "@onemind-services-llc/react-icons-ng/fa";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import PageLayout from "@/layouts/pageLayout";
import { Heading, Text, Button } from "@/elements";
import { DefaultHoverEffect } from "styles/hoverPresets";
import SecAwardsLogo from "public/home/secAwardsLogo.png";
import CmlLogo from "public/shared/cmlLogo.png";

import { HEADING_CONSTANTS, ACHIEVEMENTS_LIST } from "./constants";

const SecurityAchievements = () => {
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();

  return (
    <Box id="sec-achievements" bgColor={"gray.100"} py={12} mt={12}>
      <PageLayout marginTop={0} spacing={8}>
        <Heading variant={HeadingVariant} textAlign={"center"}>
          Our Achievements
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 5 }} gap={{ base: 8, lg: 2 }}>
          <GridItem colSpan={{ base: 1, md: 4 }}>
            <Text variant={TextVariant} color="text.100">
              {HEADING_CONSTANTS.description}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 1 }} justifyItems={"center"}>
            <Image
              src={SecAwardsLogo}
              alt="Security Awards Logo"
              width={280}
              height={250}
            />
          </GridItem>
        </SimpleGrid>
        <SimpleGrid columns={{ base: 1, sm: 2 }} gap={{ base: 8, lg: 16 }}>
          {ACHIEVEMENTS_LIST.map((achievement) => (
            <GridItem
              key={achievement.title}
              role="group"
              boxShadow={"xl"}
              p={6}
              bgColor={"white"}
              borderRadius="lg"
              _hover={DefaultHoverEffect}
            >
              <Stack justifyContent="space-between" h="100%" gap={4}>
                <HStack gap={3} color="primary.200" _groupHover={{ color: "white" }}>
                  <Icon as={achievement.icon} w={8} h={8} />
                  <Text variant={"label1"} fontWeight={550}>
                    {" "}
                    {achievement.title}
                  </Text>
                </HStack>
                <Text variant={"body2"} color="text.100" _groupHover={{ color: "white" }}>
                  {achievement.desc}
                </Text>
                <Button
                  as={Link}
                  href={achievement.pdfSrc}
                  target="_blank"
                  rel="noopener noreferrer"
                  bgColor="gray.100"
                  color="primary.200"
                  borderRadius="32px"
                  _hover={{
                    backgroundColor: "white",
                    color: "black",
                  }}
                  w="fit-content"
                  fontSize="20px"
                  fontWeight={500}
                  leftIcon={<FaRegEye />}
                >
                  Preview
                </Button>
              </Stack>
            </GridItem>
          ))}
        </SimpleGrid>
        <Box
          asChild
          alignSelf="center"
          display="flex"
          gap={1}
          bgColor="white"
          py={2}
          px={5}
          mt={4}
          style={{
            color: "#1E87F0",
            fontWeight: 600,
            marginLeft: "4px",
            fontSize: "18px",
            borderRadius: "32px",
          }}
        >
          <Link href="https://cloudmylab.com" target="_blank" rel="noopener noreferrer">
            Explore
            <Image
              src={CmlLogo}
              alt="CloudMyLab"
              width={100}
              height={100}
              style={{ display: "inline-block", verticalAlign: "middle" }}
              loading="lazy"
            />
          </Link>
        </Box>
      </PageLayout>
    </Box>
  );
};

export default SecurityAchievements;
